preloaderInit();
function preloaderInit() {
  var bodyElement = document.querySelector('body');
  var preloader = document.querySelector('.preloader');

  function removePreloader() {
    if (preloader !== null) {
      preloader.classList.add('loaded');
      setTimeout(function() {
        if (preloader.parentNode) {
          preloader.parentNode.removeChild(preloader);
        }
      }, 900);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    removePreloader();
  });

  window.onload = function() {
    removePreloader();
  };
}